import { de, enGB, es, fr, nl } from 'date-fns/locale';

const dateLocales = { de, en: enGB, es, fr, nl } as const;

export const getDateLocale = (language: string) =>
  dateLocales[language.toLowerCase() as keyof typeof dateLocales] ?? enGB;

const speechLocales = { de: 'de-DE', en: 'en-GB', es: 'es-ES', fr: 'fr-FR', nl: 'nl-NL' } as const;

export const getSpeechLocale = (language: string) =>
  speechLocales[language.toLowerCase() as keyof typeof speechLocales] ?? 'en-GB';
